// extracted by mini-css-extract-plugin
module.exports = {"container":"az_VLc","skeletonTitle":"az_WLc","skeletonIcon":"az_XLc"};